<!--  -->
<template>
  <div class="iconLine">
    <div
      v-for="index in actualScore"
      :key="index"
      :class="gradientFlag ? `iconGradient${index}` : 'iconSame'"
      class="iconInterval icon-star"
    ></div>
    <div v-for="index in greyNum" :key="index + actualScore" class="iconInterval icon-star iconGrey"></div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  name: 'rate',
  props: {
    // 分数
    score: {
      type: Number,
      default: 5
    },
    // 是否渐变
    gradientFlag: {
      type: Boolean,
      default: true
    },
    // 星星总数
    totalNum: {
      type: Number,
      default: 5
    }
  },
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {
    actualScore() {
      if (this.score > 5) {
        return 5
      } else {
        return this.score
      }
    },
    greyNum() {
      return this.totalNum - this.actualScore
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
@import url('../svg/style.css');
//@import url(); 引入公共css类
.iconLine {
  width: min-content;
  font-size: 30px;
  display: flex;
  background: linear-gradient(139.9deg, #ff6534, #ff0d43);
  -webkit-background-clip: text;
  color: transparent;
}
.iconSame {
  // background: linear-gradient(148.78deg, #ff4334 35%, #ff0d43 81.82%);
  background: #f10313;
  -webkit-background-clip: text;
  color: transparent;
}

.iconGradient1 {
  background: linear-gradient(139.9deg, #ff6534 56.05%, #ff0d43 144.19%);
  -webkit-background-clip: text;
  color: transparent;
}
.iconGradient2 {
  background: linear-gradient(134.01deg, #ff6534 38.3%, #ff0d43 135%);
  -webkit-background-clip: text;
  color: transparent;
}
.iconGradient3 {
  background: linear-gradient(148.78deg, #ff4334 35%, #ff4334 81.82%);
  -webkit-background-clip: text;
  color: transparent;
}
.iconGradient4 {
  background: linear-gradient(148.78deg, #ff4334 35%, #ff0d43 81.82%);
  -webkit-background-clip: text;
  color: linear-gradient(148.78deg, #ff4334 35%, #ff0d43 81.82%);
}
.iconGradient5 {
  background: linear-gradient(154.75deg, #ff4334 -13.18%, #ff0d43 60.19%);
  -webkit-background-clip: text;
  color: transparent;
}
.iconInterval {
  margin-right: 15px;
}
.iconGrey {
  -webkit-background-clip: unset;
  color: #d1d1d1;
  @include bgColor(#fff, unset);
}
</style>
